import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { ConnectorType, Current } from '../model';
import { commandPermissions } from './command-permissions';

export interface ConnectorStaticsEvse {
  numberedId: number;
}

export interface ConnectorRoamingSettings {
  evseId: ConnectorStaticsEvse;

  // TODO add support if needed
  // chargingProtocol: ChargingProtocol;
  connectorType: ConnectorType;
  current: Current;
  maxAmperage: number;
  maxElectricPower: number;
  phase: number;
  physicalReference?: string;
  voltage: number;
}

export interface UpdateConnectorStaticsCommand {
  connectors: ConnectorRoamingSettings[];
}

const client = createClient('/rest/operator-api/charging-stations');

export const updateConnectorStatics: SaveOperation<UpdateConnectorStaticsCommand, void, string> = postRequestFactory<
  UpdateConnectorStaticsCommand,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/update-connector-statics',
  permissionId: commandPermissions.UPDATE_CONNECTOR_STATICS
});
